import { useEffect } from 'react';
import { useMap } from 'react-map-gl';

// Bottom to top
export const PANE_ORDER = [
  'polygon-pane',
  'tile-pane',
  'raster-tile-pane',
  'flowlines-pane',
  'structures-pane',
  'boundary-pane',
];

export const MapAnchors = () => {
  const { current: map } = useMap();

  useEffect(() => {
    if (!map) return;
    const mapInstance = map.getMap();

    const addAnchors = () => {
      PANE_ORDER.forEach(paneId => {
        const anchorId = `anchor-${paneId}`;
        if (!mapInstance.getLayer(anchorId)) {
          mapInstance.addLayer({
            id: anchorId,
            type: 'background',
            layout: { visibility: 'none' },
            paint: { 'background-color': 'rgba(0,0,0,0)' },
          });
        }
      });
    };

    if (mapInstance.isStyleLoaded()) {
      addAnchors();
    } else {
      mapInstance.on('style.load', addAnchors);
    }

    return () => {
      mapInstance.off('style.load', addAnchors);
    };
  }, [map]);

  return null;
};